export default "__VITE_ASSET__y$1q8NJR__"